import firebase from 'firebase/app'

import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'

firebase.initializeApp(process.env.FIREBASE_CONFIG)

const firestore = firebase.firestore()
firestore.settings({})

const auth = firebase.auth()

const storage = firebase.storage()

function facebookProvider() {
  return new firebase.auth.FacebookAuthProvider()
}

function twitterProvider() {
  return new firebase.auth.TwitterAuthProvider()
}

function googleProvider() {
  return new firebase.auth.GoogleAuthProvider()
}

const EMAIL_PASSWORD_SIGN_IN_METHOD = firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD
const GOOGLE_SIGN_IN_METHOD =firebase.auth.GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD
const FACEBOOK_SIGN_IN_METHOD = firebase.auth.FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD
const TWITTER_SIGN_IN_METHOD = firebase.auth.TwitterAuthProvider.TWITTER_SIGN_IN_METHOD


export default {
  auth,
  firestore,
  storage,
  facebookProvider,
  twitterProvider,
  googleProvider,
  EMAIL_PASSWORD_SIGN_IN_METHOD,
  GOOGLE_SIGN_IN_METHOD,
  FACEBOOK_SIGN_IN_METHOD,
  TWITTER_SIGN_IN_METHOD
}


// WEBPACK FOOTER //
// ./src/firebase.js